import { api } from '../client';
import type { AcceptBetaDisclaimerRequest, BetaDisclaimerResponse } from '@/types/api';

/**
 * Beta disclaimer endpoints.
 *
 * Acceptance state arrives piggybacked on the login/me payloads, so the gate
 * does not need to call `get` on every load; it is provided for refetching the
 * current copy on demand. `accept` records acceptance of the current version.
 */
export const disclaimerAPI = {
  get: async (): Promise<BetaDisclaimerResponse> =>
    api.get<BetaDisclaimerResponse>('/api/beta_disclaimer'),

  accept: async (data: AcceptBetaDisclaimerRequest): Promise<BetaDisclaimerResponse> =>
    api.post<BetaDisclaimerResponse>('/api/beta_disclaimer/accept', data),
};
